// removed by extract-text-webpack-plugin
module.exports = {"Container":"Home__Container__YlG47","VaccContainer":"Home__VaccContainer__1Al7C","VaccButtonContainer":"Home__VaccButtonContainer__1bWiX","TakenContainer":"Home__TakenContainer__26a0P","NotTakenContainer":"Home__NotTakenContainer__3HrCY","TakenContent":"Home__TakenContent__y8HDt","SearchContainer":"Home__SearchContainer__2Ykp_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 62
// module chunks = 0